<template>
    <div class="flex flex-row flex-ai">
        <el-button icon="el-icon-arrow-left
    " circle type="success" class="margin-right-70" @click="prevSwiper"></el-button>
        <el-carousel :indicator-position="indicatorPosition" :interval="4000" :type="type" arrow="never" :height="height+'px'" :autoplay="false" class="flex1 lee-swiper" ref="swiper">
            <slot></slot>
        </el-carousel>
        <el-button  icon="el-icon-arrow-right
    " circle type="success" class="margin-left-70" @click="nextSwiper"></el-button>
    </div>
</template>

<script>
export default {
    name: "Swiper",
    props:{
        height:{
            type:[String,Number],
            default:260
        },
        type:{
            type:String,
            default:'card'
        },
        indicatorPosition:{
            type:String,
            default:'none'
        }
    },
    methods:{
        prevSwiper(){
            this.$refs['swiper'].prev();
        },
        nextSwiper(){
            this.$refs['swiper'].next();
        }
    }
}
</script>
